// planetInfoGenerator.js
var PlanetInfoGenerator = pc.createScript('planetInfoGenerator');

PlanetInfoGenerator.attributes.add('copyText', {type:'boolean', default:false});


// initialize code called once per entity
PlanetInfoGenerator.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
        
    this.app.on('solarGen:PlanetInfoSpawn', this.addPlanet, this);
    this.app.on('userInput:getPlanetInfo', this.getInfo, this);
    this.app.on('solarGen:SystemInfo', this.systemInfo, this);
    this.app.on('userInput:test', this.test, this);
    this.app.on('systemGen:allPlanets', this.setSysteminfo, this);
    
    this.app.on('planetInfo:civCounter', this.countCiv, this);
    this.app.on('planetInfo:stellar', this.countStellar, this);
    this.app.on('planetInfo:interStellar', this.countInterstellar, this);
    this.app.on('seeder:reset', this.reset, this);
    
    // PLANET TYPE A (HIGH TECH CIVILIZATION)
    
    this.nameSil = ["SHO", "CAL", "HUM", "CAN", "ARIS", "A'TA", "AL", "KAR", "TO", "TIS", "KOH'", "KOR", "KEH", "LA", "MIN",
                   "HOR", "REM", "RUD", "TUR", "MUR", "AR'", "DIN", "CHI", "CHA", "TEL", "BEL", "NAT", "NAR", "OURE", "ARES",
                   "HEL", "DIN'", "OL", "SHO'", "TUR", "DUR", "GUL", "GOL", "KA", "CHE", "CHAN", "CHAR", "MOR", "MIR", "MER",
                   "TOL", "ROL", "MOL", "MELE", "TELE", "SELE", "OST", "AST", "IST", "PER", "RA", "TAR"];
    this.nameDes = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'ALPHA', 'BETA', 'GAMMA', 'DELTA',
                   'EPSILON', 'ETA', 'THETA', 'IOTA', 'KAPA', 'LAMBDA', 'SIGMA', 'OMEGA', 'PRIMUS', 'SECUNDUS', 'TERTIUS',
                   "INFERIOR", "SUPERIOR", "ULTERIOR", "ULTIMA", "MAGNUS", "MINOR"];
    this.preNames = ["NEW", "AD", "PER", "DE", "ALTER", "LITTLE", "COLONIA", "TERRA"];
    
    this.typeAcomp1 = ["HOME TO ", 
                       "HOUSING ", 
                       "HARBOURING ", 
                       "HOMEWORLD OF ",
                       "HABITAT OF ",
                       "RESIDENCE OF ",
                       "CENTER OF "
                      ];
    
    this.typeAcomp2 = ["AN ADVANCED CIVILIZATION. ",
                       "A RICH CIVILIZATION. ",
                       "AN OLD CIVILIZATION. ",
                       "A HIGH-TECH CIVILIZATION. ",
                       "A SPLENDID CIVILIZATION. ",
                       "A GRAND CIVILIZATION. ",
                       "A GROWING CIVILIZATION. ",
                       "A BLOOMING CIVILIZATION. ",
                       "A PROUD CIVILIZATION. ",
                       "A SPRAWLING CIVILIZATION. ",
                       "AN ESTABLISHED CIVILIZATION. ",
                       "A GREAT CIVILIZATION. ",
                       "AN UPCOMING CIVILIZATION. ",
                       "A HONOURABLE CIVILIZATION. ",
                       "AN UNUSUAL CIVILIZATION. ",
                       "A PECULIAR CIVILIZATION. ",
                       "A PROMISING CIVILIZATION. ",
                       "A RISING CIVILIZATION. ",
                       "AN UPRISING CIVILIZATION. ",
                       "A TRADITIONAL SOCIETY. ",
                       "A GROWING SOCIETY. ",
                       "A PROUD SOCIETY. ",
                       "A RICH SOCIETY. ",
                       "A SPRAWLING SOCIETY. ",
                       "A SPLENDID SOCIETY. ",
                       "A RISING SOCIETY. "
                      ];
    
    this.typeAcomp3 = ["ITS PEOPLE ARE FAMOUS FOR ",
                       "ITS INDIVIDUALS ARE INTERGALACTICALLY KNOWN FOR ",
                       "ITS NATIVES ARE MEMORABLE FOR ",
                       "THESE FOLKS ARE INFAMOUS FOR ",
                       "THESE PEOPLES CULTURE IS MOST NOTABLE FOR ",
                       "THIS CULTURE IS NOTORIOUS FOR ",
                       "THIS PLANETS DWELLERS HAVE A PREFERENCE FOR ",
                       "INHABITANTS ARE RENOWNED FOR ",
                       "CITIZENS ARE WELL KNOWN FOR ",
                       "PEOPLE WHO HAVE A PREFERENCE FOR ",
                       "THE RESIDENTS ARE ACCLAIMED FOR ",
                       "THE POPULATION IS WIDELY CELEBRATED FOR ",
                       "THE POPULATION IS RENOWNED FOR ",
                       "THERE ARE NO FOLKS BETTER KNOWN FOR ",
                       "A CULTURE THAT IS WELL KNOWN FOR ",
                       "A CULTURE THAT IS NOTORIOUS FOR ",
                       "A CULTURE THAT IS FAMOUS FOR ",
                       "A CULTURE THAT HAS A STRONG AFFECTION FOR ",
                       "THEY ARE MOST MEMORABLE FOR ",
                       "THEY HAVE A REPUTATION FOR ",
                       "THEY HAVE A PREFERENCE FOR ",
                       "THEY CARE MOSTLY FOR ",
                       "THEY HAVE A STRONG AFFECTION FOR ",
                       "THE INHABITANTS ARE KNOWN FOR ",
                       "THESE PEOPLE ARE BETTER KNOWN FOR ",
                       "THESE GUYS ARE DISCREDITED FOR ", 
           	           "A CULTURE THAT IS OFTEN ACCLAIMED FOR ",
                       "EVERYONE KNOWS THESE FOLKS ARE FAMOUS FOR "
                      ];
    
    this.typeAcomp4 = ["THEIR SPICY KITCHEN",
                       "THEIR PHILOSOPHICAL TRADITION",
                       "THEIR FANCY TASTE IN FASHION",
                       "AN EXQUISITE CUISINE",
                       "THEIR UNUSUAL COMPANION ANIMALS",
                       "AN EXCESSIVE AND EXAGGERATED OPERA",
                       "THEIR INTEREST IN A PECULIAR BALLGAME",
                       "DEVASTATING ALCOHOLIC BEVERAGES",
                       "MONOTONOUS AND REPETITIVE POETRY",
                       "WILD AND ARCHAIC TRADITIONAL DANCES",
                       "ITS EXTRAORDINARY HOSPITALITY",
                       "THEIR EXCESSIVE LONG-LASTING FESTIVITIES",
                       "RADICAL OPINIONS ABOUT A BALANCED DIET",
                       "A BIAS TOWARDS FLAMBOYANT HAIRSTYLES",
                       "THEIR NATURAL BEAUTY",
                       "STUNNING NON-EUCLIDEAN ARCHITECTURE",
                       "PULSATING AND ROARING NIGHTLIFE",
                       "FINE ARTS AND LITERATURE",
                       "WORSHIPPING A GENUINE SATIRICAL GOD",
                       "EXCESSIVELY RECITING PROVERBS",
                       "ITS IMMENSE PRODUCTIVITY IN OFFSPRING",  
                       "THEIR DISASTROUS SENSE OF HUMOUR",
                       "THEIR ICONIC KNITTING TALENTS",
                       "THEIR QUIVERING HANDSHAKES",
                       "THEIR RELIGIOUS SONGS",  
                       "THEIR CATCHY TRADITIONAL SONGS",
                       "THEIR HILARIOUS STANDUP COMEDIANS",
                       "A MASTERY IN PROCRASTINATION",
                       "ARTISAN CRAFTSMANSHIP",
                       "DISCIPLINE AND PATIENCE WHEN STANDING IN QUEUES",
                       "SETTING THE HIGHEST SCIENTIFIC STANDARDS",
                       "BEING AMONG THE MOST TALKATIVE PEOPLE IN THE GALAXY",
                       "LIVING IN HARMONY WITH NATURE",
                       "THE OVERCONSUMPTION OF A BITTER TASTING PLANT",
                       "PREFERRING SOCIAL MEDIA OVER ANY OTHER FORM OF INTERACTION",
                       "THE CONSUMPTION OF A BEVERAGE THAT FERMENTS FOR MILLENNIA",
                       "THEIR IGNORANCE TOWARDS SCIENCE",
                       "THEIR EASILY INFLAMMABLE TEMPER",
                       "THEIR REFINED AND MOST EXQUISITE PASTRIES,",
                       "AN EXTREMLY QUESTIONABLE TASTE IN FASHION",
                       "WEARING THEIR BLASTERS VERY LOOSLY",
                       "BEING RATHER UNPLEASANT IN GENERAL",
                       "BEING THE MOST POLITE IN THE ENTIRE QUADRANT",
                       "THEIR CONTRIBUTION TO THE INTERGALACTIC ENTERTAINMENT INDUSTRY",
                       "BEING INNOVATORS IN THE BRANCH OF HOUSEHOLD TOOLS"
                       
                      ];
    
    this.typeAcomp5 = [", WHILE THE PLANET'S SPECTACULAR GEOLOGICAL FEATURES ATTRACT MILLIONS OF TOURISTS.",
                       ", WHILE THE PLANET IS EVEN MORE FAMOUS FOR ITS HIGHLY DIVERSE FAUNA.",
                       ". THE PLANET HAS RICH NATURAL RESOURCES THAT LET ITS CULTURE FLOURISH.",
                       ". THE VIBRANT AND COLORFUL CITIES ARE THE MOST VISITED IN THE WHOLE QUADRANT.",
                       ". SOME UNIQUE AND RARE CHEMICAL COMPOUNDS CAN BE FOUND AT THIS PLACE.",
                       ", THOUGH THEIR BUREAUCRATIC ORGANIZATION IS PROVERBIAL THROUGHOUT THE WHOLE GALAXY.",
                       ", THOUGH THEIR WORK ETHICS LET A LOT TO BE DESIRED.",
                       ", THOUGH THEY ARE MOSTLY INTO GAMBLING AND DRINKING.",
                       ", THOUGH THEIR MUSIC SOUNDS GROTESQUE TO OUTWORLDERS.",
                       ", THOUGH PROBABLY THEIR MOST NOTABLE FEATURE IS A LOVE FOR LONG-LASTING SIESTAS.",
                       ", AS THE PLANET'S FLORA IS UNUSUAL AND HIGHLY POPULAR AMONG BOTANISTS.",
                       ", AS THE PLANET'S BREATHTAKING MOUNTAINS ATTRACT CLIMBERS FROM ALL OVER THE GALAXY.",
                       ", ITS BIZARRE BIRDLIFE IS PRAISED BY ORNITHOLOGISTS FROM EVERY CORNER OF THE GALAXY.",
                       ". OUTSTANDING RUINS OF A SUNKEN CULTURE MAKE THIS PLANET A DESTINATION FOR ARCHAEOLOGISTS.",
                       ". A FASCINATING PLANETARY CAVE SYSTEM ALLURES EXPLORERS AND ADVENTURERS.",
                       ". GIVEN THE SYSTEM'S UNIQUE LOCATION, THE NIGHT SKY ON THIS PLANET IS PRAISED AROUND THE GALAXY.",
                       ". GEOLOGISTS LOVE THIS PLANET FOR ITS PROSPEROUS VARIETY OF MINERALS.",
                       ". THE PLANET'S FLORA HAS PRODUCED SOME OF THE MOST EXQUISITE SPICES USED FOR EXOTIC DISHES.",
                       ". THE BEAUTY OF THE PLANET'S COUNTRYSIDE HAS BEEN DESCRIBED IN ANTIQUE POETRY.",
                       ". REAL ESTATE PRICES REACH SUPERNOVA STATUS IN MANY METROPOL REGIONS OF THE SOUTHERN HEMISPHERE.",
                       ", WHILE THE PLANET'S CLIMATE ATTRACTS THE ELDERLY FROM EVERYWHERE IN THE GALAXY.",
                       ", AS THE PLANET HAS BEEN RUMOURED TO BE THE SECRET CENTRE OF AN INTERGALACTIC CONSPIRACY.",
                       ". THE CAPITAL CITY'S MOST FAMOUS SIGHT IS A 2500 FEET BRONZE STATUE OF ERWIN ORB.",
                       ". CITIES IN THE NORTHERN HEMISPHERE ARE FAMOUS FOR THEIR CRIMINAL SYNDICATES.",
                       ". THIS IS THE PLACE IF YOU ARE INTO HIGH-TECH AUGMENTATION AND IMPLANTS WITHOUT REGULATION.",               
                       ". TOURISTS ARE WELCOME. REPORTS OF INDUSTRIAL POLLUTION ARE NOTHING BUT DEFAMATORY RUMOURS.",
                       ". ANYONE WHO ENTERS NEEDS TO UNDERGO WEEKS OF SPIRITUAL CLEANSING RITUALS FIRST.",
                       ". THEIR SOCIETY IS A PERFECT UTOPIA. THEY JUST DON'T WANT TOO MANY PEOPLE TO VISIT TOO FREQUENTLY.",
                       ". IMPORTANT: ON ENTRY, IT'S ALWAYS A GOOD IDEA TO PAY A LOT OF RESPECT TO THE CUSTOM OFFICERS.",
                       ", THOUGH THEIR DEFEATIST PHILOSOPHY PREVENTS THEM FROM REALLY ENJOYING LIFE.",
                       ", WHILE THE GALAXY AGREES THEY ARE AMONG THE MOST FRIENDLY PEOPLE IN THE GALACTIC COMMUNITY.",
                       ". RUMOURS HAVE IT THAT THERE'S A SUPERIOR ALIEN CIVILIZATION HIBERNATING UNDERGROUND.",
                       ". SEISMOLOGISTS INSIST THAT DESPITE THE LATEST DEVELOPMENTS ALL CITIES ARE SAFE TO VISIT.",
                       ". THERE REALLY IS NO NEED TO BE SCARED OF THE MEGA VOLCANO FIELD. IT HAS BEEN INACTIVE FOR YEARS!",
                       ". BEWARE OF THE PECULIAR ANDROIDS SOME MERCHANTS ARE TRYING TO SELL YOU.",
                       ". THERE ARE THINGS THAT NO ONE ON THIS PLANET TALKS ABOUT. YOU WILL FIND OUT VERY QUICKLY.",
                       ", WHILE THE PLANET IS INTERGALACTICALLY KNOWN AS A VENUE FOR MANY CLASSIC HOLO-FILM DRAMAS.",
                       ". THE PLANET IS HOME TO A PROFESSIONAL INTERGALACTIC BALLGAME TEAM.",
                       ". THE DAYS WHEN THEY SINGLE-HANDEDLY INVADED THE WHOLE GALAXY ARE OF CAUSE FOREVER GONE.",
                       ". THIS PLANET HAS THE HIGHEST DENSITY OF BREWERIES IN THE WHOLE UNIVERSE.",
                       ", WHILE THEY CLAIM TO BE DESCENDANTS OF THE FIRST WAVE OF COLONIZATION.",
                       ", WHILE THEY FOLLOW THE CULT OF RTZ23, A BEING THAT ALLEGEDLY CREATED OUR UNIVERSE AS A SIMULATION.",
                       ". THE NUMBER OF LANGUAGES WITH THEIR LOCAL DIALECTS MAKE THIS PLANET A HOTSPOT FOR ETYMOLOGISTS.",
                       ", WHILE THEY INSIST THAT THERE IS NO LIFE BEFORE COFFEE!"
                      ];
    
     this.typeAcomp6 = ["CORPORATE",
                        "GERONTOCRACY",
                        "OLIGARCHY",
                        "AUTOCRACY",
                        "ANARCHY",
                        "DEMOCRACY",
                        "SOCIALISM",
                        "PLUTOCRACY",
                        "MONARCHY",
                        "DEMARCHY",
                        "ELECTOCRACY",
                        "ERGATOCRACY",
                        "GENIOCRACY",
                        "KRATEROCRACY",
                        "KRITARCHY",
                        "MERITOCRACY",
                        "NOOCRACY",
                        "PARTICRACY",
                        "STRATOCRACY",
                        "TECHNOCRACY",
                        "THEOCRACY",
                        "TIMOCRACY",
                        "ASTRACRACY",
                        "NEPOTOCRACY",
                        "OCHOLOCRACY",
                        "ADHOCRACY",
                        "ANOCRACY",
                        "BUREAUCRACY",
                        "NOMOCRACY",
                        "ALGOCRACY",
                        "ISOCRACY",
                        "MOBOCRACY",
                        "TELEDEMOCRACY",
                        "THALASSOCRACY",
                        "AUTARCHY",
                        "PATRIARCHY",
                        "SYNARCHY",
                        "IDIOCY",
                        "MATRIARCHY",
                        "SECRECY",
                        "FLASHMOBOCRACY",
                        "NOCRACY"
                       ];
    
    // PLANET TYPE B (NO CVILIZATION BUT CIVILIZATION ASSETS)
    
    this.typeBcomp1 = ["NO TRACES OF A GENUINE CIVILIZATION WERE FOUND. ",
                       "IT SHOWS TRACES OF AN ANCIENT CIVILIZATION. ",
                       "HAS SEEMINGLY BEEN HOME TO A NOW-DECEASED CIVILIZATION. ",
                       "NEVER HOSTED A CIVILIZATION. ",
                       "NO SIGNS OF AN ORIGINAL CIVILIZATION. ",
                       "HOMEWORLD TO A CIVILIZATION MILLENNIA AGO. ",
                       "THERE ONCE WAS A CIVILIZATION. THEY HAD AN ORANGE PRESIDENT. NOW THEY'RE GONE. SO SAD. TOTAL LOSERS. ",
                       "CLIMATE CHANGED IN AN UNFAVOURABLE MANNER MILLENNIA AGO. "
                      ];
    
    this.typeBcomp2 = ["THERE IS A CORPORATE MINING OPERATION IN PLACE. ",
                       "THE PLANET IS UNDER SCIENTIFIC EXAMINATION. ",
                       "THIS PLANET IS USED FOR RECREATIONAL ACTIVITIES. ",
                       "USED AS A HIDEOUT BY PIRATES. ",
                       "PART OF - AND AN IMPORTANT STOP FOR THE GREAT GALACTIC TRADE ROUTE. ",
                       "USED FOR CORPORATE EXPERIMENTATION. ",
                       "EXILE FOR A REBELLIOUS ORGANIZATION FROM ANOTHER SYSTEM. ",
                       "THE PLANET IS UNDER EXAMINATION DUE TO CONTAMINATION. ",
                       "VISITORS ARE MOSTLY ADVENTURERS AND HUNTERS. ",
                       "VISITORS ENJOY EXCEPTIONAL GEOLOGIC FORMATIONS. ",
                       "THIS IS THE HIDEOUT OF A DOGMATIC PARTISAN RELIGIOUS SECT. ",
                       "IT IS A SANCTUARY PLANET VISITED BY PILGRIMS FROM ALL OVER THE QUADRANT. ",
                       "THE PLANET IS CURRENTLY IN THE PROCESS OF TERRAFORMING. ",
                       "THERE IS A TERRAFORMING OPERATION IN PLACE. ",
                       "THERE IS AN IMPORTANT MILITARY FACILITY ON THE GROUND. "
                      ];
    
    // PLANET TYPE C (GAS GIANT)
    
    this.typeCcomp1 = ["RICH OF HIGH ENERGETIC COMPOUNDS ",
                       "RICH OF UNSTABLE COMPOUNDS ",
                       "CONTAINS RARE COMPOUNDS "
                      ];
    
    
    this.typeCcomp2 = ["MAINLY FROM GCCT-STANDARD GROUP A. ",
                       "MAINLY FROM GCCT-STANDARD GROUP B ",
                       "MAINLY FROM GCCT-STANDARD GROUP C. ",
                       "MAINLY FROM GCCT-STANDARD GROUP D. "
                      ];
    
    this.typeCcomp3 = ["THE PLANET EMITS TREMENDOUS AMOUNTS OF RADIATION. ",
                       "THE PLANET EMITS A LARGE AMOUNT OF RADIATION. ",
                       "THE PLANET EMITS A MEDIUM AMOUNT OF RADIATION. ",
                       "THE PLANET EMITS A MODERATE AMOUNT OF RADIATION. "
                      ];
    
    this.typeCcomp4 = [" PERIODICALLY SHIFTING PLASMA STORMS."];
    this.typeCcomp5 = [" A MODEST MINING OPERATION IS IN PLACE.", 
                       " CORPORATE MINING IN PROGRESS.", 
                       " MINING CONSORTIUM TERRITORY!", 
                       " FUELING IMMENSE ORBITAL CITIES.",
                       " HARBOURS HUGE ORBITAL CITIES.",
                       " A HUGE POPULATION INHABITS THESE STATIONS.",
                       " THE ORBITING STATIONS ARE LARGE AS CITIES.",
                       " SURROUNDED MASSIVE ORBITAL HABITATS."
                      ];
    
    // PLANET TYPE D (NO CIV NO TECHNOLOGY)
    
    this.typeDcomp1 = ["NEITHER DOES THIS PLANET HARBOUR ANY ADVANCED LIFEFORM NOR HAS IT BEEN EXPLORED YET.",
                       "THIS PLANET IS LACKING AN ADVANCED LIFEFORM. THERE ARE PLANS FOR A SCIENTIFIC MISSION.",
                       "RUMOURS OF A CIVILIZATION IN ITS EARLIEST STAGES COULD NOT YET BE CONFIRMED. A METHODIC EXPLORATION NEEDS TO BE UNDERTAKEN.",
                       "NO ONE HAS EVER CARED TO EXPLORE THIS WORLD THOUGH THERE ARE NO SIGNATURES THAT INDICATED ADVANCED LIFEFORMS.",
                       "THE PLANET REMAINS UNEXPLORED TO THE PRESENT DAY. NO SIGN OF AN ADVANCED LIFEFORM HAS BEEN OBSERVED SO FAR.",
                       "PLANS FOR A SCIENTIFIC EXAMINATION OF THIS PLACE ARE PENDING WHILE THERE ARE NO OBSERVABLE TRACES OF ADVANCED LIFE.",
                       "SINCE THIS PLANET DOES NOT SHOW ANY EVIDENCE FOR ADVANCED LIFE, IT HAS BEEN CHOSEN FOR COLONIZATION.",
                       "A PLANET LACKING ADVANCED LIFEFORMS READY TO BE A TEST SITE FOR CORPORATE RESEARCH AND DEVELOPMENT.",
                       "ALL INFORMATION ABOUT THIS PLANET IS CLASSIFIED.",
                       "THIS PLANET HAS NOT BEEN EXPLORED BY ANYONE YET.",
                       "CORPORATE RUMOURS SAY AN EXPEDITION HAS BEEN LOST ON THIS PLANET.",
                       "PEOPLE IN THIS QUADRANT AVOID THIS PLANET FOR SUPERSTITIOUS REASONS.",
                       "EXPLORATION IN PROSPECT.",
                       "THERE IS NOT VERY MUCH KNOWN ABOUT THIS PLANET.",
                       "NEEDS YET TO BE VISITED BY EXPLORERS AND SCIENTISTS.",
                       "THIS PLANET IS DESERTED.",
                       "ALLEGEDLY REMAINS OF AN ANCIENT SUPER-CIVILIZATION WERE FOUND ON THIS PLANET."
                      ]; 
    
    this.systemComp1 = ["CAPITAL", 
                        "LEADING PROVINCE", 
                        "MAIN PROVINCE", 
                        "IMPORTANT COLONY", 
                        "HEADQUARTER", 
                        "CENTRAL TERRITORY",
                        "METROPOL REGION", 
                        "CAPITAL SEAT", 
                        "CENTER", 
                        "HEART", 
                        "NUCLEUS", 
                        "ORIGIN", 
                        "BASE", 
                        "METROPOLIS",           
                        "MEGALOPOLIS", 
                        "MUNICIPAL SYSTEM", 
                        "PRINCIPAL"
                       ];
    
    this.systemComp2 = ["COLONY", 
                        "REGION", 
                        "PROVINCE", 
                        "FEDERATE AREA", 
                        "ASSOCIATE", 
                        "STATE", 
                        "TERRITORY", 
                        "PROTECTORATE", 
                        "AUTONOMOUS EXCLAVE", 
                        "COUNTY",
                        "STRONGHOLD",
                        "PREFECTURE",
                        "FEDERATE STATE",
                        "AUTONOMOUS STATE",
                        "ARCHPROTECTORATE",
                       ];
    
    this.systemComp3 = ["EXCLAVE", 
                        "ENCLAVE", 
                        "MINOR TERRITORY", 
                        "SATELLITE", 
                        "BORDER REGION",
                        "ESTATE",
                        "SETTLEMENT",
                        "REGION",
                        "CENT",
                        "ADMINISTRATIVE UNIT",
                        "PROTECTORATE"
                       ];
    
    this.systemComp4 = ["OUTPOST", 
                        "SETTLEMENT", 
                        "FRONTIER",
                        "TRANSQUADRANT COLONY",
                        "LAST STRONGHOLD",
                        "REMOTE TERRITORY",
                        "CORRIDOR",
                        "LANDMARK",
                        "HIDEOUT",
                        "VANTAGE POINT"
                       ];
    
    this.systemComp5 = [" OF A GREAT FEDERATION", 
                        " OF A PANGALACTIC EMPIRE", 
                        " OF A GALACTIC NATION", 
                        " OF THE GREAT CONSORTIUM", 
                        " OF THE GALACTIC REPUBLIC", 
                        " OF A REPUBLIC",
                        " OF A REGIONAL CORE NATION", 
                        " OF A CONFEDERACY", 
                        " OF A COLONIAL EMPIRE", 
                        " OF THE GALACTIC COMMONWEALTH", 
                        " OF A COALITION OF SYSTEMS",
                        " OF THE DOMINION",
                        " OF THE PRIME EXARCHY",
                        " OF A SYNDICATE",
                        " OF AN EMPIRE",
                        " OF THE TRADE CORPORATION"
                       ];
    
    
    this.plntEnt = [];
    this.plntInfo = [];
    this.plntDesc = [];
    this.systemName = null;
    this.systemDesc = null;
    this.planetNumber = 0;
    this.planetType = null;
    this.systemInformation = null;
    this.techLevel = 0;
    this.planetCounter = 0;
    this.civCounter = 0;
    this.comp1 = null;
    this.comp2 = null;
    this.plntInfoTag = this.app.root.findByName('planetNumberTag'); //naming is inverted to to original classification
    this.plntDescTag = this.app.root.findByName('planetInfo'); // ... planing to change it when it works most likely going to forget it
    this.fwaLogo = this.app.root.findByName('fwaLogo');
    
    this.specialPlanet = [
        [
         0.7069082996848122, 
         6, 
         'TERRA FWA', 
         'THIS PLANET WAS ONCE THE POWERHOUSE OF THE HOLOFLASH INDUSTRY BEFORE AN EXPERIMENTAL GEOENGINEERING-PROJECT TOOK PLACE. TODAY IT IS A FAVOURITE DESTINATION FOR ALL CODING HEROES, THE PLANET INHABITANTS ARE PRAISING THEIR ETERNAL PRESIDENT ROB FORD.',
         this.fwaLogo
        ]
    ];
};


// aehrm .. it is called test. but actually the main routine that gives back planet name and description - cough (check event subscription)
PlanetInfoGenerator.prototype.test = function(nm) {

    if(nm.name == 'system'){
        this.plntInfoTag.element.text = 'SYSTEM ' + this.systemName  + '\n' + 'TYPE: ' + this.planetType;
        this.plntDescTag.element.text = this.systemInformation;
    }
    
    for(var b = 0; b < this.plntInfo.length; b++){

        if(this.plntEnt[b].children[1] == nm){
            this.plntInfoTag.element.text = this.plntInfo[b];
            this.plntDescTag.element.text = this.plntDesc[b];
            return;
        }
    }
};

PlanetInfoGenerator.prototype.addPlanet = function(nm){
    
    var inf = this.generateInfo();
    var desc = this.generateDesc(nm);
       
    for(var lp = 0; lp < this.specialPlanet.length; lp++){
        if(this.theSeed == this.specialPlanet[lp][0]){
            if(this.specialPlanet[lp][1] == this.planetCounter){
                inf = this.specialPlanet[lp][2];
                desc = this.specialPlanet[lp][3];
            }
        }
    }
    
    this.plntEnt.push(nm);
    this.plntInfo.push(inf);
    this.plntDesc.push(desc);
    
    this.planetCounter += 1;
    if(this.planetCounter === this.planetNumber+1){
        this.setSysteminfo();
    }
};

PlanetInfoGenerator.prototype.generateInfo = function(){
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.seedScript.getUniqueRandom() + this.planetCounter);
    
    var rndSils = Math.floor(this.randomize()*2)+2;
    var tmpAr = [];
    tmpAr = this.nameSil;
    var theName = '';
    for(var a = 0; a < rndSils; a++){
        var rnd = Math.floor(this.randomize()*tmpAr.length);
        theName = theName + tmpAr[rnd];
        tmpAr.splice(rnd,0);
    }
    if(Math.floor(this.randomize() > 0.5)){
        theName = theName + ' ' + this.nameDes[Math.floor(this.randomize()*this.nameDes.length)]; 
    }
    if(Math.floor(this.randomize() > 0.5)){
        theName = this.preNames[Math.floor(this.randomize()*this.preNames.length)] + ' ' + theName; 
    }
    var info = 'NAME:' + '\n' + theName;
    return info;
};

PlanetInfoGenerator.prototype.generateDesc = function(tp){
    
    var thePlanet = tp.children[1].children[1].name;  
    
    if(tp.children[1].name == 'habitable'){
        
        if(tp.children[1].children[1].script.planetGenerator.civilization){
            this.techLevel += 80;
            this.civCounter += 1;
        }
        
        if(tp.children[1].children[1].script.planetGenerator.satelliteSwitch){
            this.techLevel += 20;
        }        
        
        if(tp.children[1].children[1].script.planetGenerator.station){
            this.techLevel += 40;
        }    
        
        if(tp.children[1].children[1].script.planetGenerator.stellar){
            this.techLevel += 80;
        }      
        
        if(tp.children[1].children[1].script.planetGenerator.interStellar){
            this.techLevel += 80;
        }           
                
        
        if(tp.children[1].children[1].script.planetGenerator.civilization){
            var rnd = Math.floor(this.randomize()*this.typeAcomp6.length - 1);
 
            if(rnd == -1){
                rnd = this.typeAcomp6.length - 1;
            }
            var organization = this.typeAcomp6[rnd];
            var desc1 = 
                this.typeAcomp1[Math.floor(this.randomize()*this.typeAcomp1.length)] +
                this.typeAcomp2[Math.floor(this.randomize()*this.typeAcomp2.length)] +
                this.typeAcomp3[Math.floor(this.randomize()*this.typeAcomp3.length)] +
                this.typeAcomp4[Math.floor(this.randomize()*this.typeAcomp4.length)] +
                this.typeAcomp5[Math.floor(this.randomize()*this.typeAcomp5.length)] +
                "\n \nPOLITICAL ORGANIZATION: " +  organization
            ; 
           return desc1;
           
        } else {
            
            if( tp.children[1].children[1].script.planetGenerator.stellar === true || tp.children[1].children[1].script.planetGenerator.interStellar === true || tp.children[1].children[1].script.planetGenerator.station === true){
                var desc3 = this.typeBcomp1[Math.floor(this.randomize()*this.typeBcomp1.length)] +
                   this.typeBcomp2[Math.floor(this.randomize()*this.typeBcomp2.length)];
                
                return desc3;
            } else {
                var desc7 = this.typeDcomp1[Math.floor(this.randomize()*this.typeDcomp1.length)];
                return desc7;
            }

        }
        
    }
    
    if (tp.children[1].name == 'rockPlanet'){
        
        if(tp.children[1].children[1].script.planetGenerator.station){
            this.techLevel += 40;
        }    
        
        if(tp.children[1].children[1].script.planetGenerator.stellar){
            this.techLevel += 80;
        }      
        
        if(tp.children[1].children[1].script.planetGenerator.interStellar){
            this.techLevel += 80;
        }
        
        if(tp.children[1].children[1].script.planetGenerator.civilization){
            var desc2 = 
                this.typeAcomp1[Math.floor(this.randomize()*this.typeAcomp1.length)] +
                this.typeAcomp2[Math.floor(this.randomize()*this.typeAcomp2.length)] +
                this.typeAcomp3[Math.floor(this.randomize()*this.typeAcomp3.length)] +
                this.typeAcomp4[Math.floor(this.randomize()*this.typeAcomp4.length)] +
                this.typeAcomp5[Math.floor(this.randomize()*this.typeAcomp5.length)] +
                "\n \nPOLITICAL ORGANIZATION: " +  this.typeAcomp6[Math.floor(this.randomize()*this.typeAcomp6.length)]; 
                this.civCounter += 1;
           return desc2;
            
        } else {
            
            if( tp.children[1].children[1].script.planetGenerator.stellar === true || tp.children[1].children[1].script.planetGenerator.interStellar === true || tp.children[1].children[1].script.planetGenerator.station === true){
               var desc4 = this.typeBcomp1[Math.floor(this.randomize()*this.typeBcomp1.length)] +
                   this.typeBcomp2[Math.floor(this.randomize()*this.typeBcomp2.length)];
                
                return desc4; 
            } else {
                var desc8 = this.typeDcomp1[Math.floor(this.randomize()*this.typeDcomp1.length)];
                return desc8;
            }
            
        }      
     }
    
    if (tp.children[1].name == 'gasGiant'){
        
       
        var cntr = 0;
        var stations = null;
        for(var stns = 0; stns < 5; stns++){
            if(tp.children[1].children[2].children[stns].enabled){
                cntr += 1;
            }
        }
        if(cntr == 5){
            cntr = Math.floor(this.randomize() * this.typeCcomp5.length - 4);
            cntr += 4; 
        }
        if(cntr === 0){
            stations = "";
        } else {
            stations = this.typeCcomp5[cntr]; 
        }
            
        if(tp.children[1].children[1].name == 'coldGasGiant'){
            var desc5 = this.typeCcomp1[Math.floor(this.randomize()*this.typeCcomp1.length)] +
                this.typeCcomp2[Math.floor(this.randomize()*this.typeCcomp2.length)] +
                this.typeCcomp3[Math.floor(this.randomize()*this.typeCcomp3.length)] +
                stations; 
            return desc5;
            
        } else {
            var desc6 = this.typeCcomp1[Math.floor(this.randomize()*this.typeCcomp1.length)] +
                this.typeCcomp2[Math.floor(this.randomize()*this.typeCcomp2.length)] +
                this.typeCcomp3[Math.floor(this.randomize()*this.typeCcomp3.length)] + 
                this.typeCcomp4[0] + 
                stations;
            
            return desc6;
        }

    }
    return "ALL THE INFORMATION YOU CAN HAZ ABOUT THIS PLANET HERE EVEN IF I DON'T KNOW WHAT YET TOO SAY SO";
};

PlanetInfoGenerator.prototype.systemInfo = function(nmb, typ){
    
    this.planetNumber = nmb;
    this.planetType = typ;
    this.systemInformation = 'PLANETS: ' + nmb + '\n' + 'REQUESTING INFORMATION... ' + '\n' + 'SCANNING DATABASE ...';
    this.plntDescTag.element.text = this.systemInformation;
    if(this.planetNumber === 0){
        this.systemInformation = 'PLANETS: ' + nmb + '\n' + 'THERE ARE NO PLANETS... ' + '\n' + 'IN THIS SYSTEM!';
    }

};

PlanetInfoGenerator.prototype.setSysteminfo = function(){
    this.comp2 = this.systemComp5[Math.floor(this.randomize()*this.systemComp5.length)];
    if(this.techLevel >= 750){
       // console.log('VERY HIGH');
        this.comp1 = this.systemComp1[Math.floor(this.randomize()*this.systemComp1.length)];
    }
    if(this.techLevel >= 500 && this.techLevel <= 749){
        //console.log('HIGH');
        this.comp1 = this.systemComp2[Math.floor(this.randomize()*this.systemComp2.length)];
    }
    if(this.techLevel >= 100 && this.techLevel <= 499){
       // console.log('AVERAGE');
        this.comp1 = this.systemComp3[Math.floor(this.randomize()*this.systemComp3.length)];
    }
    if(this.techLevel >= 0 && this.techLevel <= 99){
      //  console.log('LOW');
        this.comp1 = this.systemComp4[Math.floor(this.randomize()*this.systemComp4.length)];
    }
    this.systemInformation = this.comp1 + this.comp2 + '\n' + 'PLANETS: ' + this.planetNumber + '\n' + 'POPULATED: ' + this.civCounter + '\n' + 'KARDASHEV-BARROW SCORE: ' + this.techLevel;
    this.plntDescTag.element.text = this.systemInformation;
};


PlanetInfoGenerator.prototype.reset = function() {
    this.plntEnt = [];
    this.plntInfo = [];
    this.plntDesc = [];
    this.systemName = null;
    this.systemDesc = null;
    this.techLevel = 0;
    this.planetCounter = 0;
    this.systemName = this.generateInfo();
    this.planetCounter = 1;
    this.civCounter = 0;
    this.comp1 = null;
    this.comp2 = null;
    this.plntInfoTag.element.text = 'SYSTEM ' + this.systemName + '\n' + 'TYPE: ' + this.planetType;
};


// update code called every frame
PlanetInfoGenerator.prototype.update = function(dt) {
};

// swap method called for script hot-reloading
// inherit your script state here
// PlanetInfoGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

